import type { Address } from "viem"

import { DomainEvent } from "@/domains/events"

export class VoteAllocatedEvent extends DomainEvent {
  static readonly TYPE = "vote.allocated"
  readonly type = VoteAllocatedEvent.TYPE
  constructor(
    public readonly address: Address,
    public readonly value: number,
  ) {
    super()
  }
}

export class VoteRemovedEvent extends DomainEvent {
  static readonly TYPE = "vote.removed"
  readonly type = VoteRemovedEvent.TYPE
  constructor(public readonly address: Address) {
    super()
  }
}

export class VoteResetEvent extends DomainEvent {
  static readonly TYPE = "vote.reset"
  readonly type = VoteResetEvent.TYPE
  constructor() {
    super()
  }
}
